import React from "react";
import { Container, Row, Col, Card, CardBody, Table } from "reactstrap";

const CampaignsSkeleton: React.FC = () => (
	<Container fluid className="py-5">
		<Row className="align-items-center mb-4 placeholder-glow">
			<Col xs="12" md="6" className="d-flex align-items-center">
				<div className="rounded-circle bg-secondary me-3" style={{ width: 48, height: 48 }} />
				<div>
					<div className="placeholder col-6 mb-2" style={{ height: "1.25rem" }} />
					<div className="placeholder col-4" style={{ height: "1rem" }} />
				</div>
			</Col>
			<Col xs="12" md="6" className="text-md-end mt-3 mt-md-0">
				<div className="placeholder col-3" style={{ height: "2.5rem" }} />
			</Col>
		</Row>

		<Card className="mb-4 shadow-sm placeholder-glow">
			<CardBody>
				<div className="d-flex flex-wrap gap-3">
					<div className="placeholder col-2" style={{ height: "3rem" }} />
					<div className="placeholder col-2" style={{ height: "3rem" }} />
					<div className="placeholder col-3" style={{ height: "3rem" }} />
					<div className="placeholder col-3" style={{ height: "3rem" }} />
					<div className="placeholder col-1" style={{ height: "3rem" }} />
				</div>
			</CardBody>
		</Card>

		<Card className="shadow-sm">
			<CardBody className="p-0 placeholder-glow">
				<Table borderless className="mb-0">
					<thead>
						<tr>{Array(5).fill(null).map((_, i) => (
							<th key={i}><span className="placeholder col-12" /></th>
						))}</tr>
					</thead>
					<tbody>
						{Array(5).fill(null).map((_, r) => (
							<tr key={r}>
								{Array(5).fill(null).map((_, c) => (
									<td key={c}><span className="placeholder col-12" /></td>
								))}
							</tr>
						))}
					</tbody>
				</Table>
			</CardBody>
		</Card>
	</Container>
);

export default CampaignsSkeleton;
